module.exports = __webpack_public_path__ + "static/img/bg_section_geometric_dark.37c1486.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutTheGreatSavior/bg_section_geometric_dark.png
// module id = 6H7Y
// module chunks = 1